import { Identifiable, CostProfile } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getCostProfiles(httpClient: HttpClient) {
  return () =>
    httpClient
      .sendHttpRequest<{
        _embedded: { costProfiles: Identifiable<CostProfile>[] };
      }>({
        endpoint: "/costProfiles",
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) => _embedded.costProfiles);
}

export { getCostProfiles };
